import { Component, computed, forwardRef, input, output, Signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiLoadingSpinnerComponent } from '@siemens/element-ng/loading-spinner';
import { SelectItem, SiSelectModule } from '@siemens/element-ng/select';
import { CustomControl } from '../../../form/custom-control/custom-control.component';
import { AwardCommitteeMeeting } from '@tran-monorepo/interfaces';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatAwardCommitteeMeetingDate } from '../../../../utils';

@Component({
    selector: 'tran-application-award-committee-meeting-select',
    templateUrl: './award-committe-meeting-select.component.html',
    imports: [SiSelectModule, TranslatePipe, SiLoadingSpinnerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AwardCommitteeMeetingSelectComponent),
            multi: true
        }
    ]
})
export class AwardCommitteeMeetingSelectComponent extends CustomControl<string | null> {
    public readonly isMeetingsLoading = input<boolean>(false);
    public readonly hasMeetingsNextPage = input<boolean>(false);
    public readonly meetings = input<AwardCommitteeMeeting[]>([]);

    public readonly loadMoreMeetings = output<void>();

    protected readonly options: Signal<SelectItem<string>[]> = computed(() =>
        this.meetings().map(meeting => ({
            type: 'option',
            label: `${formatAwardCommitteeMeetingDate(meeting)}`,
            value: meeting.id
        }))
    );
}
